import React, { useState } from 'react';
import ProductPassport from 'app/components/product/ProductPassport';
import PlanInfo from 'app/components/product/PlanInfo';
import Button from 'seedly-component-library/button-new';
import get from 'lodash/get';
import { ChevronDown, ChevronUp } from 'react-feather';
import { Product } from 'app/entity/product/productTypes';

const RelatedProductList = (props: { products: Product[] }) => {
  const { products = [] } = props;
  if (products.length === 0) return null;
  const [showAll, toggleShowAll] = useState(false);

  const displayShowAll = products.length > 3;
  const displayCount = showAll ? products.length : 3;
  const slicedProducts = products.slice(0, displayCount);

  const dataSource = slicedProducts.map((product, index) => {
    const { id } = product;
    const plans = get(product, 'plans', []);
    const showPlan = index === 0 && plans.length > 0;
    const isSinglePlan = plans.length === 1;
    return (
      <div
        className="rounded-lg p-2 border-neutral-400 border border-solid h-fit w-full"
        key={id}
      >
        <div className="flex flex-col w-full gap-4">
          <ProductPassport product={product} />
          {showPlan &&
            (isSinglePlan ? (
              <PlanInfo plan={plans[0]} showTitle={false} />
            ) : (
              <div className="rounded-lg p-2 h-fit">
                <PlanInfo plan={plans[0]} />
              </div>
            ))}
        </div>
      </div>
    );
  });

  return (
    <div className="rounded-lg p-4 bg-white h-fit">
      <div className="flex flex-col gap-4 w-full">
        <p className="font-bold text-sm">Related Products</p>
        <div className="list gap-3">{dataSource}</div>
        {displayShowAll && (
          <div className="flex justify-center gap-4 w-full mt-2">
            <Button
              variant="ghost"
              icon={showAll ? <ChevronUp /> : <ChevronDown />}
              onClick={() => toggleShowAll(!showAll)}
            >
              {showAll ? 'Show Less Products' : 'Show More Products'}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default RelatedProductList;
